import React, { FC } from "react"
import { AndroidFilled, AppleFilled } from "@ant-design/icons"
import { GamePlatformType } from "../store/types"

interface Props {
  platform: GamePlatformType
  isInstallable?: boolean
  isBudgetExhausted?: boolean
}

/**
 * Tab label for a platform: icon, name, and a colored status dot so admins
 * can eyeball platform health when switching between Android/iOS tabs.
 */
export const PlatformTabLabel: FC<Props> = ({ platform, isInstallable, isBudgetExhausted }) => {
  const dotColor = isBudgetExhausted
    ? "#ff4d4f"
    : isInstallable === false
      ? "#bfbfbf"
      : "#52c41a"
  const Icon = platform === GamePlatformType.IOS ? AppleFilled : AndroidFilled
  const iconColor = platform === GamePlatformType.IOS ? "#999" : "#3DDC84"

  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
      <Icon style={{ color: iconColor, fontSize: 14 }} />
      <span>{platform === GamePlatformType.IOS ? "iOS" : "Android"}</span>
      <span
        style={{
          width: 8,
          height: 8,
          borderRadius: "50%",
          background: dotColor,
          display: "inline-block",
          marginLeft: 2,
        }}
      />
    </span>
  )
}
